import React, { useState } from 'react';
import '../App.css';

const SECTIONS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'productos', label: 'Productos' },
  { key: 'usuarios', label: 'Usuarios' },
  { key: 'categorias', label: 'Categorías' },
  { key: 'pedidos', label: 'Pedidos' },
  { key: 'reportes', label: 'Reportes' },
  { key: 'contactos', label: 'Consultas y Reclamos' },
];

const Admin = () => {
  const [section, setSection] = useState('dashboard');

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <h3 className="admin-sidebar-title">Admin</h3>
        <nav className="admin-nav">
          {SECTIONS.map(s => (
            <button
              key={s.key}
              className={`admin-nav-btn${section === s.key ? ' active' : ''}`}
              onClick={() => setSection(s.key)}
            >
              {s.label}
            </button>
          ))}
        </nav>
      </aside>
      <main className="admin-main">
        {section === 'dashboard' && (
          <div className="admin-dashboard">
            <h2>Dashboard</h2>
            <div className="admin-dashboard-cards">
              <div className="admin-card">Ventas hoy<br /><span className="admin-card-value">$0</span></div>
              <div className="admin-card">Pedidos<br /><span className="admin-card-value">0</span></div>
              <div className="admin-card">Usuarios<br /><span className="admin-card-value">0</span></div>
              <div className="admin-card">Stock bajo<br /><span className="admin-card-value">0</span></div>
            </div>
          </div>
        )}
        {section === 'productos' && (
          <div className="admin-section">
            <h2>Gestión de Productos</h2>
            <div className="admin-table-placeholder">Tabla de productos (CRUD visual)</div>
            <button className="admin-add-btn">Agregar producto</button>
            {/* Formulario visual para agregar/editar producto (solo visual, sin lógica) */}
            <form className="admin-producto-form-placeholder">
              <input type="text" placeholder="Nombre del producto" required />
              <textarea placeholder="Descripción" rows={3} />
              <input type="number" placeholder="Precio" min="0" step="0.01" required />
              <input type="number" placeholder="Stock" min="0" required />
              <input type="file" multiple accept="image/*" className="admin-producto-img-input" />
              <div className="admin-producto-img-aviso">
                <em>Soporte para subir varias imágenes por producto (solo visual, sin backend aún).</em>
              </div>
              <button className="admin-add-btn" type="submit">Guardar producto</button>
            </form>
          </div>
        )}
        {section === 'usuarios' && (
          <div className="admin-section">
            <h2>Gestión de Usuarios</h2>
            <div className="admin-table-placeholder">Tabla de usuarios (CRUD visual)</div>
          </div>
        )}
        {section === 'categorias' && (
          <div className="admin-section">
            <h2>Gestión de Categorías</h2>
            <div className="admin-table-placeholder">Tabla de categorías (CRUD visual)</div>
            <button className="admin-add-btn">Agregar categoría</button>
          </div>
        )}
        {section === 'pedidos' && (
          <div className="admin-section">
            <h2>Gestión de Pedidos</h2>
            <div className="admin-table-placeholder">Tabla de pedidos (CRUD visual)</div>
          </div>
        )}
        {section === 'reportes' && (
          <div className="admin-section">
            <h2>Reportes</h2>
            <div className="admin-table-placeholder">Gráficos y reportes de ventas, productos, usuarios, etc.</div>
          </div>
        )}
        {section === 'contactos' && (
          <div className="admin-section">
            <h2>Consultas y Reclamos</h2>
            <div className="admin-table-placeholder">
              <table className="admin-contactos-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Usuario</th>
                    <th>Tipo</th>
                    <th>Mensaje</th>
                    <th>Fecha</th>
                    <th>Estado</th>
                    <th>Respuesta</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td>Julio Pintos</td>
                    <td>Reclamo</td>
                    <td>Producto defectuoso</td>
                    <td>2024-07-14</td>
                    <td>Pendiente</td>
                    <td><button className="admin-add-btn">Responder</button></td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td>Agustin Burgos</td>
                    <td>Consulta</td>
                    <td>¿Cuándo llega mi pedido?</td>
                    <td>2024-07-13</td>
                    <td>Respondido</td>
                    <td><button className="admin-add-btn">Ver</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="admin-producto-img-aviso">
              <em>Solo los administradores pueden ver y responder consultas, devoluciones, quejas y reclamos enviados por usuarios registrados.</em>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default Admin; 